if (!customElements.get('product-form')) {
    customElements.define('product-form', class AddToCart extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form[action$="/cart/add"]');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event
        }

        formSubmit(evt) {
            evt.preventDefault();
            this.closest('.product_form').classList.add('loading');
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const formData = new FormData(this.form);
            const quantityInput = this.closest('.product_form').querySelector('input[name="quantity"]');
            if (quantityInput) {
                formData.append('quantity', quantityInput.value);
            }
            config.body = formData;
            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        // Error function
                        this.errorMessage(response)
                        return;
                    }
                    // Succses function
                    this.closest('.product_form').classList.remove('loading');
                    this.succses(response);
                    document.querySelector('.form_message.success_message button').addEventListener('click', function (e){
                        e.target.closest('.form_message.success_message').classList.add('hidden_msg');
                    });
                })
                .catch((error) => {
                    this.closest('.product_form').classList.remove('loading');
                });
        }

        errorMessage(resp) {
            this.closest('.product_form').classList.remove('loading');
            if(resp.status == 422){
                alert('The maximum available quantity of the product has been exceeded. Will add as much as is in stock.')
            }
        }

        succses(res) {
            document.querySelector('.form_message.success_message').style.display = 'flex';
            this.closest('.product_form').classList.add('loading');
            function updateCart(id, quantity){
                fetch(`${window.routes.cart_change_url}.js`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: id, quantity: quantity })
                }).then(response => {
                    if (!response.ok) {
                        return response.text().then(text => { throw new Error(text); });
                    }
                    return response.json();
                }).then((data) => {
                    cartRender();
                }).catch(error => console.error("Error updating cart:", error));

            }
            function submitCoupon(coupon){
                if(coupon != ''){
                    window.location.href = `${window.shopUrl}/checkout?discount=${encodeURIComponent(coupon)}`;
                }
            }
            function cartRender(){
                const headerCart = document.querySelector('.header_cart');
                let cartForm = document.querySelector('#cart-form');
                let cartItem = cartForm.querySelector('.header_cart-head').dataset.items;
                const headerButtonCart = document.querySelector('.menu_carts.js-open-header-cart');
                const headerButtonCartCount = headerButtonCart.querySelector('.count');
                const headerButtonCartCountMob = document.querySelector('.mobile_menu-carts .count');
                fetch(window.shopUrl, {
                    method: "GET",
                    headers: {
                        "X-Requested-With": "XMLHttpRequest"
                    }
                })
                    .then(response => response.text())
                    .then(html => {
                        let parser = new DOMParser();
                        let doc = parser.parseFromString(html, "text/html");
                        let newCartForm2 = doc.querySelector(".header_cart>form");
                        let currentCart = document.querySelector(".header_cart");
                        currentCart.querySelector('form').remove();
                        if (newCartForm2 ) {
                            currentCart.insertAdjacentElement('afterbegin', newCartForm2)
                        }
                        headerButtonCartCount.textContent = newCartForm2.querySelector('.header_cart-head').dataset.items;
                        headerButtonCartCountMob.textContent = newCartForm2.querySelector('.header_cart-head').dataset.items;
                        /* - - - - - - - - - - - - - -       init count item   - - - - - - - - - - - - - - - */
                        const countInputs = $("#cart-form .count_input");
                        if (countInputs.length) {
                            countInputs.each(function (i, elem) {
                                const input = $(elem).find("input");
                                const decBtn = $(elem).find(".count_input-dec");
                                const incBtn = $(elem).find(".count_input-inc");

                                const inc = () => {
                                    const value = input.val();
                                    input.val(+value + 1);
                                };

                                const dec = () => {
                                    const value = input.val();

                                    if (+value > 0) {
                                        input.val(+value - 1);
                                    } else {
                                        input.val(0);
                                    }
                                };

                                decBtn.on("click", dec);
                                decBtn.on("keydown", (e) => {
                                    if (e.keyCode === 13) {
                                        dec();
                                    }
                                });

                                incBtn.on("click", inc);
                                incBtn.on("keydown", (e) => {
                                    if (e.keyCode === 13) {
                                        inc();
                                    }
                                });
                            });
                        }
                        /* - - - - - - - - - - - - - -       init show note   - - - - - - - - - - - - - - - */
                        $(".js-cart-form-msg-show").on("click", function (e) {
                            e.preventDefault();
                            var $this = $(this);
                            var $parent = $this.closest(".bordered_btn");
                            var $wrapper = $parent.closest(".cart_form-footer-msg");
                            $wrapper.addClass("show")
                        });
                        let debounceTimer;
                        let noteText = newCartForm2.querySelector('[name="note"]');
                        if (noteText) {
                            noteText.addEventListener("blur", function() {
                                headerCart.classList.add('loading');
                                fetch(`${window.routes.cart_update_url }.js`, {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({ note: noteText.value })
                                }).then(() => {
                                    headerCart.classList.remove('loading');
                                });
                            });
                        }

                        newCartForm2.addEventListener('submit', function (e) {
                            e.preventDefault();
                            window.location.href = `${window.shopUrl}/checkout`;

                        });
                        cartForm = document.querySelector('#cart-form');
                        cartItem = cartForm.querySelector('.header_cart-head').dataset.items;

                        if(cartItem > 0){
                            let buttsQuantity = newCartForm2.querySelectorAll('.count_input-dec, .count_input-inc');
                            buttsQuantity.forEach(function (item) {
                                item.addEventListener('click', function (e){
                                    headerCart.classList.add('loading');
                                    setTimeout(function () {
                                        let itemQuantity = item.closest('.count_input').querySelector('input[name="quantity"]').value;
                                        let itemId = item.closest('.count_input').querySelector('input[name="quantity"]').dataset.id;
                                        updateCart(itemId, itemQuantity);
                                    },500);
                                })
                            })
                            let inputQuantity  = newCartForm2.querySelectorAll('input[name="quantity"]');
                            inputQuantity.forEach(function (item) {
                                item.addEventListener('input', function () {
                                    clearTimeout(debounceTimer);
                                    debounceTimer = setTimeout(() => {
                                        headerCart.classList.add('loading');
                                        let itemId = item.dataset.id;
                                        let itemQuantity = item.value;
                                        updateCart(itemId, itemQuantity);
                                    }, 500);
                                })
                            })
                            let buttsRemove = newCartForm2.querySelectorAll('[data-remove]');
                            buttsRemove.forEach(function (item){
                                item.addEventListener('click',function () {
                                    headerCart.classList.add('loading');
                                    let id = item.dataset.remove;
                                    updateCart(id, 0);
                                })
                            })

                            let cartCoupon = document.querySelector('.cart_coupon');
                            if(cartCoupon !== null){
                                cartCoupon.querySelector('.form_apply_coupone').addEventListener('click', function (e) {
                                    e.preventDefault();
                                    headerCart.classList.add('loading');
                                    let coupon = cartCoupon.querySelector('input[name="coupon"]').value;
                                    if(coupon != ''){
                                        submitCoupon(coupon);
                                    }else{
                                        headerCart.classList.remove('loading');
                                    }
                                })
                            }
                        }
                        headerCart.classList.remove('loading');
                    })
                    .catch(error => console.error("Error updating cart:", error));
            }
            cartRender();
            if(document.querySelector('.menu_carts.js-open-header-cart') !== null){
                document.querySelector('.menu_carts.js-open-header-cart').click();
                this.closest('.product_form').classList.remove('loading');
            }
        }
    });
}

function convertSize() {
    var activeSizeType = document.querySelector("input[name=\"size_type\"]:checked");
    var sizeTypeValue = activeSizeType.getAttribute("value");
    var sizeRadio = $("input[name=\"size\"]");
    sizeRadio.each(function (i, elem) {
        var sizeValue = $(this).attr("value");
        var title = activeSizeType.dataset.title ? activeSizeType.dataset.title : false;
        var multiplier = activeSizeType.dataset.multiplier ? parseFloat(activeSizeType.dataset.multiplier) : false;
        var sizeValues = sizeValue.split("x").map(function (item) {
            var value = parseInt(item);
            if (multiplier) {
                value = Math.floor(value * multiplier)
            }
            return value
        });
        var newValue = sizeValues.join(" x ") + (title ? " ".concat(title) : "");
        var label = elem.nextElementSibling;
        label.innerHTML = newValue
    })
}
